"use client";

import { useRef, useEffect, useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { X } from "lucide-react";

export function VideoModal({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (open && videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [open]);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm" />
        <Dialog.Content
          className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8"
          onPointerDownOutside={() => setOpen(false)}
        >
          <VisuallyHidden.Root>
            <Dialog.Title>Demo Video</Dialog.Title>
          </VisuallyHidden.Root>
          <div className="relative w-full max-w-5xl aspect-video">
            <Dialog.Close className="absolute -top-10 right-0 sm:-top-2 sm:-right-10 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-surface-secondary/80 border border-surface-border text-content-secondary hover:text-content hover:bg-surface-hover transition-colors cursor-pointer">
              <X size={16} />
            </Dialog.Close>
            {open && (
              <video
                ref={videoRef}
                key={String(open)}
                autoPlay
                controls
                playsInline
                className="w-full h-full rounded-xl shadow-2xl shadow-black/60"
                src="/api/video"
                onEnded={() => setOpen(false)}
              />
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
